import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#0F3D61',
    },
    secondary: {
      main: '#6DB144',
      contrastText: '#fff',
    },
  },
});
